import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApprovalsEquipmentsApi } from '@core/api/approvals-equipments/approvals-equipments.api';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { CustomMessagesService } from '@core/errors/custom-messages.service';

import english from './../../i18n/en.json';
import spanish from './../../i18n/es.json';
import portuguese from './../../i18n/pt.json';

@Component({
  selector: 'dialog-approvals-reject',
  templateUrl: './dialog-approvals-reject.component.html',
  styleUrls: ['./dialog-approvals-reject.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogApprovalsEquipmentsRejectComponent {
  public rejectForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public approval: any,
    public matDialogRef: MatDialogRef<DialogApprovalsEquipmentsRejectComponent>,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private fuseProgressBarService: FuseProgressBarService,
    private approvalsEquipmentsApi: ApprovalsEquipmentsApi,
    private customMessageService: CustomMessagesService,
    private formBuilder: FormBuilder,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.rejectForm = this.formBuilder.group({
      message: ['', Validators.required]
    });
  }

  public rejectApproval(): void {
    this.fuseProgressBarService.show();

    this.approvalsEquipmentsApi
      .refuseEquipment(this.approval.id, this.rejectForm.value.message)
      .subscribe((refusedApproval) => {
        this.fuseProgressBarService.hide();
        if (refusedApproval) {
          this.customMessageService.success('APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_SUCCESSFULLY_REJECTED');
          this.matDialogRef.close(true);
        }
      });
  }
}
